import type { NavbarLogo, Page } from '../../schemas/validation';

export interface LogoUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (logoData: NavbarLogo) => void;
  siteId: string;
  initialData?: Partial<NavbarLogo>;
  isLoading?: boolean;
  /** Available pages for link selection */
  pages?: Page[];
  /** Whether pages are still loading */
  isLoadingPages?: boolean;
}

export type LogoMode = 'text' | 'image';

export interface TabConfig {
  id: LogoMode;
  label: string;
  icon: React.ComponentType<{ size: number }>;
  desc: string;
}

export interface TextConfigProps {
  logoData: Partial<NavbarLogo>;
  onChange: (data: Partial<NavbarLogo>) => void;
}

export interface ImageConfigProps {
  logoData: Partial<NavbarLogo>;
  onChange: (data: Partial<NavbarLogo>) => void;
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearImage: () => void;
  isUploading: boolean;
  hasImage: boolean;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
}

export interface LinkSettingsProps {
  logoData: Partial<NavbarLogo>;
  onChange: (data: Partial<NavbarLogo>) => void;
  /** Available pages for link selection */
  pages?: Page[];
  /** Whether pages are still loading */
  isLoadingPages?: boolean;
}

export interface LogoPreviewProps {
  logoData: Partial<NavbarLogo>;
  activeTab: LogoMode;
  hasImage: boolean;
}

export const DEFAULT_LOGO_DATA: Partial<NavbarLogo> = {
  mode: 'text',
  text: '',
  textSize: 'medium',
  textWeight: 'bold',
  textColor: '#000000',
  imageWidth: 120,
  imageHeight: 48,
  lockAspectRatio: true,
  linkTarget: '_self',
};
